import React from "react";
import classes from "./bulkSpareLotListPage.module.css";
import { BulkSpareLotListFilterPage } from "./bulkSpareLotListFilter/BulkSpareLotListFilterPage";
import { BulkSpareLotListTablePage } from "./bulkSpareLotListTable/BulkSpareLotListTablePage";

export const BulkSpareLotListPage = () => {
  return (
    <div className={classes.box}>
      <BulkSpareLotListFilterPage />
      <BulkSpareLotListTablePage />
    </div>
  );
};
